// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>

<section class="box" ng-if="\$ctrl.deposit">
  <sub-header header="'Manual rollover'"></sub-header>

  <div class="info info--deposit">
    <div class="info-detail">
      <span class="key">Product name:</span>
      <span class="value">{{\$ctrl.depositType.productDefinition.productName}}</span>
    </div>
    <div class="info-detail">
      <span class="key">Product number:</span>
      <span class="value">
        {{\$ctrl.deposit.productNumber}}
      </span>
    </div>
    <div class="info-detail">
      <span class="key">Available balance:</span>
      <span class="value currency--positive">
        {{\$ctrl.deposit.balance | nxCurrency}}
      </span>
    </div>
    <div class="override">
      <span class="key">Override amount:</span>
      <span class="value">
        <input type="checkbox"
               ng-model="\$ctrl.overrideCheckbox"
               ng-change="\$ctrl.resetOverride()"/>
      </span>
    </div>
  </div>

  <div class="alert alert--danger" ng-if="\$ctrl.transactionForm.\$valid && (!\$ctrl.defaultForecast || (\$ctrl.overrideCheckbox && !\$ctrl.forecast))">
    Perform forecast in order to continue to rollover
    <validator condition="false"></validator>
  </div>

  <h2 class="section-header">Please confirm the following:</h2>
  <form name="\$ctrl.transactionForm">
    <table class="misc-transaction__table table table--generate-row-ids">
      <thead>
      <tr ng-if="\$ctrl.overrideCheckbox">
        <td></td>
        <td></td>
        <td ng-if="\$ctrl.overrideCheckbox">
          Default
        </td>
        <td ng-if="\$ctrl.overrideCheckbox">
          Override
        </td>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td></td>
        <td>New term</td>
        <td>
          <div class="range-input">
            <div class="min-max">
              <glue-container prepend="'min.'" append="'days'">
                <input disabled
                       type="number"
                       ng-model="\$ctrl.depositType.minimalTerm"/>
              </glue-container>
            </div>
            <input required
                   type="number"
                   class="value"
                   step="1"
                   min="{{\$ctrl.depositType.minimalTerm}}"
                   max="{{\$ctrl.depositType.maximumTerm}}"
                   ng-change="\$ctrl.onUpdateTerm()"
                   ng-model="\$ctrl.request.term">
            <div class="min-max">
              <glue-container prepend="'max.'" append="'days'">
                <input disabled
                       type="number"
                       ng-value="\$ctrl.depositType.maximumTerm"/>
              </glue-container>
            </div>
          </div>
        </td>
        <td/>
      </tr>
      <tr>
        <td></td>
        <td>Matured amount</td>
        <td>
          <cash ng-model="\$ctrl.deposit.balance" ng-disabled="true"></cash>
        </td>
        <td>
          <button class="btn btn-info"
                    ng-disabled="!\$ctrl.canComputeForecast()"
                    type="button"
                    ng-click="\$ctrl.recalculateForecast()">
          Recalculate forecast
          </button>
        </td>
      </tr>
      <tr ng-repeat="fee in \$ctrl.defaultForecast.beforeRolloverFees">
        <td></td>
        <td>
          <span>Fee {{\$ctrl.feeDefinitions.get(fee.feeDefinitionId).feeName}} on rollover</span>
          <help ng-if="\$ctrl.feeDefinitions.get(fee.feeDefinitionId).bankExpense" title="Bank expense"></help>
        </td>
        <td>
          <cash value="fee.amount" ng-disabled="true"></cash>
        </td>
        <td>
          <cash ng-model="fee.overrideAmount"
                ng-if="\$ctrl.overrideCheckbox"
                required>
          </cash>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>Gross interest</td>
        <td>
           <cash value="\$ctrl.defaultForecast.withholdingTax + \$ctrl.defaultForecast.netInterest" ng-disabled="true"></cash>
        </td>
        <td>
          <cash ng-model="\$ctrl.request.grossInterestOverrideAmount"
                ng-if="\$ctrl.overrideCheckbox"
                ng-change="\$ctrl.clearForecast()"
                required>
          </cash>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>Withholding tax</td>
        <td>
          <cash value="\$ctrl.defaultForecast.withholdingTax" ng-disabled="true"></cash>
        </td>
        <td>
          <cash value="\$ctrl.forecast.withholdingTax"
                ng-disabled="true"
                required
                ng-if="\$ctrl.overrideCheckbox">
          </cash>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>Net interest</td>
        <td>
          <cash value="\$ctrl.defaultForecast.netInterest" ng-disabled="true"></cash>
        </td>
        <td>
          <cash value="\$ctrl.forecast.netInterest"
                ng-disabled="true"
                required
                ng-if="\$ctrl.overrideCheckbox">
          </cash>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>Rollover amount</td>
        <td>
          <cash value="\$ctrl.defaultForecast.rolloverAmount" ng-disabled="true"></cash>
        </td>
        <td>
          <cash value="\$ctrl.forecast.rolloverAmount"
                ng-disabled="true"
                required
                ng-if="\$ctrl.overrideCheckbox">
          </cash>
        </td>
      </tr>
      <tr ng-repeat="fee in \$ctrl.defaultForecast.certificationFees">
        <td></td>
        <td>
          <span>Fee {{\$ctrl.feeDefinitions.get(fee.feeDefinitionId).feeName}} on certification</span>
          <help ng-if="\$ctrl.feeDefinitions.get(fee.feeDefinitionId).bankExpense" title="Bank expense"></help>
        </td>
        <td>
          <cash value="fee.amount" ng-disabled="true"></cash>
        </td>
        <td>
          <cash ng-model="fee.overrideAmount"
                ng-if="\$ctrl.overrideCheckbox"
                required>
          </cash>
        </td>
      </tr>
      <tr ng-repeat="fee in \$ctrl.defaultForecast.afterRolloverFees">
        <td></td>
        <td>
          <span>Fee {{\$ctrl.feeDefinitions.get(fee.feeDefinitionId).feeName}} after rollover</span>
          <help ng-if="\$ctrl.feeDefinitions.get(fee.feeDefinitionId).bankExpense" title="Bank expense"></help>
        </td>
        <td>
          <cash value="fee.amount" ng-disabled="true"></cash>
        </td>
        <td>
          <cash ng-model="fee.overrideAmount"
                ng-if="\$ctrl.overrideCheckbox"
                required>
          </cash>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>Net rollover amount</td>
        <td>
          <cash value="\$ctrl.defaultForecast.netRolloverAmount" ng-disabled="true"></cash>
        </td>
        <td>
          <cash value="\$ctrl.forecast.netRolloverAmount"
                ng-disabled="true"
                required
                ng-if="\$ctrl.overrideCheckbox">
          </cash>
        </td>
      </tr>
      <tr ng-if="\$ctrl.shouldKeepSpecialInterestRate()">
        <td></td>
        <td>New interest rate</td>
        <td>
          <glue-container append-percentage="true">
            <input type="number"
                   required
                   min="0.0001"
                   step="0.0001"
                   ng-change="\$ctrl.recalculatePreterminationRates()"
                   ng-model="\$ctrl.request.depositInterest.interestRate">
          </glue-container>
        </td>
        <td/>
      </tr>
      <tr ng-if="\$ctrl.shouldKeepSpecialInterestRate()">
        <td></td>
        <td>Pretermination first half interest rate (25% of new interest rate)</td>
        <td>
          <glue-container append-percentage="true">
            <input disabled
                   type="number"
                   ng-value="\$ctrl.request.depositInterest.preterminationFirstHalfInterestRate">
          </glue-container>
        </td>
        <td/>
      </tr>
      <tr ng-if="\$ctrl.shouldKeepSpecialInterestRate()">
        <td></td>
        <td>Pretermination second half interest rate (50% of new interest rate)</td>
        <td>
          <glue-container append-percentage="true">
            <input disabled
                   type="number"
                   ng-value="\$ctrl.request.depositInterest.preterminationSecondHalfInterestRate">
          </glue-container>
        </td>
        <td/>
      </tr>
      <tr>
        <td></td>
        <td>New maturity date</td>
        <td class="help-container">
          <date output-format="date"
                ng-disabled="true"
                ng-model="\$ctrl.maturityDate"></date>
          <help title="Term and Maturity date could change if it falls on a holiday or non-working weekend"></help>
        </td>
        <td/>
      </tr>
      <tr>
        <td></td>
        <td>On maturity</td>
        <td>
          <select required
                  ng-disabled="\$ctrl.type.maturityStrategies.length === 1"
                  ng-change="\$ctrl.calculateForecast()"
                  ng-options="o.value as o.label for o in \$ctrl.maturityStrategies"
                  ng-model="\$ctrl.request.maturityStrategy">
          </select>
        </td>
        <td/>
      </tr>
      <tr>
        <td></td>
        <td>Interests withdrawal before maturity</td>
        <td>
          <select required
                  ng-disabled="\$ctrl.type.creditingStrategies.length === 1"
                  ng-options="o as o | prettyEnum for o in \$ctrl.depositType.creditingStrategies"
                  ng-model="\$ctrl.request.creditingStrategy">
          </select>
        </td>
        <td/>
      </tr>
      <tr ng-if="\$ctrl.isCreditingStrategyAllowed()">
        <td></td>
        <td>Interests crediting interval</td>
        <td>
          <input
            required
            type="number"
            class="value"
            ng-model="\$ctrl.request.creditingInterval"
            min="1"
            max="{{\$ctrl.depositType.maximumTerm}}">
        </td>
        <td/>
      </tr>
      <tr ng-if="\$ctrl.isCreditingStrategyAllowed()">
        <td></td>
        <td>Interest crediting cycle type</td>
        <td>
          <select
            required
            ng-model="\$ctrl.request.creditingCycleType"
            ng-options="c.value as c.label for c in \$ctrl.cycleTypes">
          </select>
        </td>
        <td/>
      </tr>
      <tr>
        <td></td>
        <td>System date</td>
        <td>
          <date output-format="date"
                ng-model="\$ctrl.branch.systemDate"
                ng-disabled="true"></date>
        </td>
        <td/>
      </tr>
      </tbody>
    </table>

    <div class="buttons">
      <button class="btn btn-warning"
              type="button"
              ng-click="\$ctrl.redirectBack()">
        Cancel
      </button>
      <button class="btn btn-success"
              ng-click="\$ctrl.rollover()"
              type="button"
              ng-disabled="\$ctrl.transactionForm.\$invalid || !\$ctrl.defaultForecast || (\$ctrl.overrideCheckbox && !\$ctrl.forecast)">
        Rollover
      </button>
    </div>

  </form>

</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/term-deposits/manual-rollover/manual-rollover.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;